<template lang="pug">
	BannerGaleriaTemplate.tiptap-gallery(:ativo.sync="active", :length="images.length")
		ul.main
			li(v-for="(image, index) in images", :key="index", :class="{ active: index === active, loading: !loaded[index] }")
				button.zoom(type="button", :aria-label="zoomLabel(image)", @click="zoom(image)")
					img(
						:src="image.src",
						:alt="image.alt",
						loading="lazy",
						decoding="async",
						@load="markLoaded(index)",
						@error="markLoaded(index)"
					)
				p(v-if="image.caption") {{ image.caption }}
		template(v-slot:nav="{ toggleBanner }")
			ul.nav
				li(v-for="thumb in thumbs", :key="thumb.index", :class="{ loading: !loaded[thumb.index] }")
					button(type="button", :aria-label="thumbLabel(thumb)", @click="showThumb(toggleBanner, thumb.index)")
						img(:src="thumb.src", alt="", loading="lazy", decoding="async", @load="markLoaded(thumb.index)", @error="markLoaded(thumb.index)")
</template>

<script>
import BannerGaleriaTemplate from '@components/BannerGaleriaTemplate/BannerGaleriaTemplate'

export default {
	name: 'component-tiptap-gallery',
	components: {
		BannerGaleriaTemplate,
	},
	props: {
		images: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			active: 0,
			loaded: {},
		}
	},
	computed: {
		// O `TiptapContent` recria o array a cada render (ex.: quando outro bloco assíncrono
		// carrega); só uma troca real de imagens deve voltar ao começo
		imagesKey() {
			return this.images.map(image => image.src).join('\n')
		},
		// Mesma regra da `Galeria` legada: as duas seguintes à ativa, ou as duas últimas.
		// A .nav só mostra duas; as demais ficariam no DOM, escondidas mas ainda focáveis.
		// Cada miniatura guarda o índice original (a legada perdia o índice ao fatiar).
		thumbs() {
			const items = this.images.map((image, index) => ({ ...image, index }))
			return items.length - 2 > this.active ? items.slice(this.active + 1, this.active + 3) : items.slice(-2)
		},
	},
	watch: {
		imagesKey() {
			this.active = 0
			this.loaded = {}
		},
	},
	methods: {
		markLoaded(index) {
			this.$set(this.loaded, index, true)
		},
		thumbLabel(thumb) {
			const label = `Ver imagem ${thumb.index + 1}`
			return thumb.alt ? `${label}: ${thumb.alt}` : label
		},
		// A miniatura clicada some da lista; o foco vai para a imagem que ela abriu
		showThumb(toggleBanner, index) {
			toggleBanner(index)
			this.$nextTick(() => {
				const button = this.$el.querySelector('.main li.active .zoom')
				if (button)
					button.focus()
			})
		},
		zoomLabel(image) {
			return image.alt ? `Ampliar imagem: ${image.alt}` : 'Ampliar imagem'
		},
		// Mesmo modal da TiptapFigure
		zoom(image) {
			this.$store.commit('setImage', { ativo: true, content: { image: image.src, alt: image.alt, text: '', caption: image.caption } })
		},
	},
}
</script>

<style lang="stylus" scoped src="./Gallery.styl"></style>
